import axios, {
  type AxiosError,
  type AxiosRequestConfig,
  type AxiosResponse,
} from "axios";
import { getToken } from "@/utils/firebase";

const assetsBaseURL = "/assets-service";

const requestInterceptor = async (
  config: AxiosRequestConfig
): Promise<AxiosRequestConfig> => {
  try {
    const token = await getToken();
    if (!config.headers) {
      config.headers = {};
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  } catch {
    return config;
  }
};

const responseInterceptor = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const errorInterceptor = (error: AxiosError): Promise<never> => {
  return Promise.reject(error);
};

export const apiClient = axios.create({});
apiClient.interceptors.request.use(requestInterceptor);
apiClient.interceptors.response.use(responseInterceptor, errorInterceptor);

export const apiClientJSON = axios.create({
  responseType: "json",
});
apiClientJSON.interceptors.request.use(requestInterceptor);
apiClientJSON.interceptors.response.use(responseInterceptor, errorInterceptor);

export const apiClientAssets = axios.create({
  baseURL: assetsBaseURL,
});
apiClientAssets.interceptors.request.use(requestInterceptor);
apiClientAssets.interceptors.response.use(
  responseInterceptor,
  errorInterceptor
);

export const apiClientJSONAssets = axios.create({
  baseURL: assetsBaseURL,
  responseType: "json",
});
apiClientJSONAssets.interceptors.request.use(requestInterceptor);
apiClientJSONAssets.interceptors.response.use(
  responseInterceptor,
  errorInterceptor
);
